// extracted by mini-css-extract-plugin
export default {"loading":"LoadingElement_loading__+mIW9","spin":"LoadingElement_spin__D+wsR"};